import { render, staticRenderFns } from "./ModalPaieskaAtmetimasBylos.vue?vue&type=template&id=164a64fa&scoped=true&"
import script from "./ModalPaieskaAtmetimasBylos.vue?vue&type=script&lang=js&"
export * from "./ModalPaieskaAtmetimasBylos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a64fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VChip,VContainer,VDataTable,VIcon,VProgressCircular})
